"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var windowBreakpoints = [{
  device: "MOBILE",
  width: 768
}, {
  device: "TABLET",
  width: 1024
}]; // returns current device based on theme breakpoints

var getClientDevice = function getClientDevice() {
  var d; // Set window width/height to state
  // Checks width against devices

  if (typeof window !== "undefined") {
    var _windowBreakpoints$fi;

    d = (_windowBreakpoints$fi = windowBreakpoints.find(function (breakPoint) {
      return window.innerWidth <= breakPoint.width;
    })) == null ? void 0 : _windowBreakpoints$fi.device;
  }

  return d || "DESKTOP";
};

var _default = getClientDevice;
exports["default"] = _default;